/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Header_Title_Line2Inputs */



/**
* | output |
* | --- |
* | "your compliance team" |
*
* @param {Pricing_Header_Title_Line2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_header_title_line2 = /** @type {((inputs?: Pricing_Header_Title_Line2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Header_Title_Line2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Compliance-Team")
	return /** @type {LocalizedString} */ ("your compliance team")
});